import { cn } from 'cn';
import type { NotificationType } from '#ui/constants';
import { BaseButton } from '../Button';
import { Icon } from '../Icon';

export type TopLineBannerProps = {
  type: NotificationType;
  message: string;
  label?: string;
  className?: string;
  onDismiss?: () => void;
};

const baseClasses = cn('flex items-center px-4 py-3');

const theme: Record<NotificationType, string> = {
  default: cn('bg-neutral-100 text-white'),
  info: cn('bg-neutral-100 text-white'),
  success: cn('bg-green-100 text-white'),
  warning: cn('bg-orange-100 text-neutral-200'),
  danger: cn('bg-red-100 text-white'),
};

export function TopLineBanner({
  message,
  type = 'default',
  label,
  className,
  onDismiss,
  ...rest
}: TopLineBannerProps) {
  return (
    <div
      role={['warning', 'danger'].includes(type) ? 'alert' : 'banner'}
      className={cn(baseClasses, theme[type], className)}
      {...rest}
    >
      <span className="typ-headline-xs">{message}</span>
      <span className="flex-1" />
      {label ? <span className="typ-ui">{label}</span> : null}
      {typeof onDismiss === 'function' ? (
        <BaseButton className="ml-3" onClick={onDismiss}>
          <Icon type="cross" size="tiny" />
        </BaseButton>
      ) : null}
    </div>
  );
}
